import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  TitleStrategy,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { provideAuth } from '@sisoma/auth';
import { provideMedia } from '@sisoma/media/providers';
import { provideUiLayout } from '@sisoma/ui';

import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { AdminTitleStrategy } from './core/navigation/title-strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // The HTTP + auth layer (fp1-03). This also registers `HttpClient` via
    // `provideHttpClient(withFetch(), withInterceptors([authInterceptor]))`, so
    // do NOT add `provideHttpClient` separately. `forbiddenUrl` targets the
    // local 403 route; `loginUrl`/`apiUrl` come from the build environment.
    provideAuth({
      apiUrl: environment.apiUrl,
      loginUrl: environment.loginUrl,
      forbiddenUrl: '/forbidden',
    }),
    // Namespaced so the sidenav-collapsed setting is not shared with the
    // other SISOMA apps served from the same origin.
    provideUiLayout({ storageKey: 'admin.sidenav-collapsed' }),
    // The FCA document upload goes direct to Cloudinary through `@sisoma/media`;
    // this registers config only (same `apiUrl` as `provideAuth`, which is what
    // lets the signing call carry credentials). The upload service itself stays
    // component-provided, so nothing here becomes a singleton. Imported from
    // `@sisoma/media/providers`, not the `@sisoma/media` barrel, because this
    // file is eager: the barrel here would put the lazily-used media code into
    // the initial bundle.
    provideMedia({ apiUrl: environment.apiUrl }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    { provide: TitleStrategy, useClass: AdminTitleStrategy },
  ],
};
